import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import VenueResults from '../venue-results/venue_results.container';
import Modal from 'react-responsive-modal';
import NewVenue from '../new-venue/new_venue.container';
import EditVenue from '../edit-venue/edit_venue.container';
import PropTypes from 'prop-types';
import withAuth from '../../../../AuthHOC/withAuth';

class VenueListPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			editModalOpen: false,
			id: ''
		}
		this.onOpenModal = this.onOpenModal.bind(this);
		this.onCloseModal = this.onCloseModal.bind(this);
		this.onOpenEditModal = this.onOpenEditModal.bind(this);
		this.onCloseEditModal = this.onCloseEditModal.bind(this);
	}

	onOpenModal = () => {
		this.setState({open: true});
	}

	onCloseModal = () => {
		this.setState({open: false});
	}

	onOpenEditModal = (id) => {
		this.setState({
			editModalOpen: true,
			id: id
		});
	}

	onCloseEditModal = () => {
		this.setState({editModalOpen: false});
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.form_success === true)
		{
			this.setState({open: false});
		}
		if(nextProps.edit_success === true)
		{
			this.setState({editModalOpen: false});
		}
	}
    render () {
		const { open, editModalOpen } = this.state;
        return (
            <div className="venues">
				<div className="page-head mb_30">
					<div className="head">
						<h1 className="page-title">Venue</h1>
						<nav>
							<ol className="breadcrumb page-title">
								<li className="breadcrumb-item"><Link to="/">Home</Link></li>
								<li className="breadcrumb-item current">Venue</li>
							</ol>
						</nav>
					</div>
					<div className="actions">
						<button onClick={this.onOpenModal} className="btn btn-orange">Create Venue</button>
					</div>
				</div>
				<div className="box">
					<VenueResults onOpenEditModal={this.onOpenEditModal} />
				</div>
				<Modal
					open={open}
					onClose={this.onCloseModal}
					showCloseIcon= {false}
					center
					classNames={{
						modal: "modal fade show"
					}}
				>
					<div className="modal-dialog modal-lg modal-dialog-centered">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Venue</h5>
								<button type="button" className="close" onClick={this.onCloseModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<NewVenue />
							</div>
						</div>
					</div>
				</Modal>
				<Modal 
					open={editModalOpen}
					onClose={this.onCloseEditModal}
					showCloseIcon= {false}
					center
					classNames={{
						modal: "modal fade show"
					}}
				>
					<div className="modal-dialog modal-lg modal-dialog-centered">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Venue</h5>
								<button type="button" className="close" onClick={this.onCloseEditModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<EditVenue id={this.state.id} />
							</div>
						</div>
					</div>
				</Modal>
			</div>
        );
    }
}

VenueListPage.propTypes = {
	form_success: PropTypes.bool
}

export default withAuth(VenueListPage,['administrator']);